import {FormEventHandler, forwardRef, ReactNode} from 'react'

import cn from 'classnames/bind'

import FormTips from 'components/blocks/FormTips'
import MobxDragFile from 'components/elements/fields/MobxDragFile'
import MobxSelect from 'components/elements/fields/MobxSelect'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {Col, Row} from 'components/elements/grid'
import usStates from 'src/configs/usStates'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubCompanyInfo.module.scss'

const cx = cn.bind(s)

interface IFieldsPayStubCompanyInfoProps {
	className?: string
	children?: ReactNode | string
	onChange?: FormEventHandler<HTMLDivElement>
}

const FieldsPayStubCompanyInfo = forwardRef<HTMLDivElement, IFieldsPayStubCompanyInfoProps>(
	({className, children, ...props}, ref) => {
		const payStubStore = usePayStubStore()
		return (
			<div className={cx('company', className)} data-testid="company-info" {...props} ref={ref}>
				{children}
				<FormTips />
				<div className={cx('company--fields')}>
					<Row className={cx('company__row')}>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'Employer (Company) name'}
								placeholder="Your Employer or Company Name"
								store={payStubStore.companyInfo}
								name="employerName"
								required
								variant="editable"
							/>
						</Col>
						<Col md={6}>
							<MobxTextInput
								wrapperClassName={cx('field')}
								label={'Employer telephone number'}
								placeholder="123-456-7890"
								store={payStubStore.companyInfo}
								name="employerTelephone"
								variant="editable"
							/>
						</Col>
					</Row>
					<MobxTextInput
						wrapperClassName={cx('field')}
						label={'Street address 1'}
						placeholder="Your Employer Address"
						store={payStubStore.companyInfo}
						name="streetAddress1"
						required
						variant="editable"
					/>
					<MobxTextInput
						wrapperClassName={cx('field')}
						label={'Street address 2'}
						placeholder="Suite 1234"
						store={payStubStore.companyInfo}
						name="streetAddress2"
						variant="editable"
					/>
					<Row className={cx('company__row')}>
						<Col md={4}>
							<MobxTextInput
								wrapperClassName={cx('city-field', 'field')}
								label={'City'}
								placeholder="Your Employer City"
								store={payStubStore.companyInfo}
								name="city"
								required
								variant="editable"
							/>
						</Col>
						<Col md={4}>
							<MobxSelect
								name="state"
								placeholder="Choose state"
								label="State"
								store={payStubStore.companyInfo}
								wrapperClassName={cx('state-field', 'field')}
								required
								data-testid="state"
								variant="editable"
								options={usStates}
							/>
						</Col>
						<Col md={4}>
							<MobxTextInput
								wrapperClassName={cx('zip-field', 'field')}
								label={'Zip code'}
								placeholder="12345"
								store={payStubStore.companyInfo}
								name="zipCode"
								required
								variant="editable"
								maxLength={5}
							/>
						</Col>
					</Row>
					<div className={cx('logo__row')}>
						<div className={cx('logo__col')}>
							<MobxDragFile
								name="payrollLogo"
								store={payStubStore.companyInfo}
								className={cx('logo-field', 'field')}
								label="Payroll processor logo"
							/>
						</div>
						<div className={cx('logo__col')}>
							<MobxDragFile
								name="employerLogo"
								store={payStubStore.companyInfo}
								className={cx('field')}
								label="Employer logo"
							/>
						</div>
					</div>
				</div>
			</div>
		)
	},
)

FieldsPayStubCompanyInfo.displayName = 'FieldsPayStubCompanyInfo'

export default FieldsPayStubCompanyInfo
